// namespace (소문자)
export const NAMESPACE = 'xeronote';
//actions
export const FETCH_DEVICE_LIST = 'FETCH_DEVICE_LIST';
export const FETCH_DIV_MONTH = 'FETCH_DIV_MONTH';
export const FETCH_PLANS = 'FETCH_PLANS';
export const FETCH_TELECOM_LIST = 'FETCH_TELECOM_LIST';
export const FETCH_NICKNAME = 'FETCH_NICKNAME';

//mutations
export const SET_DEVICE_LIST = 'SET_DEVICE_LIST';
export const SET_DIV_MONTH = 'SET_DIV_MONTH';
export const SET_PLANS = 'SET_PLANS';
export const SET_TELECOM_LIST = 'SET_TELECOM_LIST';
export const SET_NICKNAME = 'SET_NICKNAME';

//getters
export const DEVICE_LIST = 'DEVICE_LIST';
export const DIV_LIST = 'DIV_LIST';
export const PLANS = 'PLANS';
export const TELECOM_LIST = 'TELECOM_LIST';
export const NICKNAME = 'NICKNAME';
